export default function ({ legend, series }) {
  return {
    tooltip: {
      trigger: 'item',
      formatter: '{a} <br/>{b}: {c} ({d}%)'
    },
    legend: {
      type: 'scroll',
      orient: 'vertical',
      itemWidth: 8,
      itemHeight: 8,
      width: 450,
      right: '5%',
      left: '60%',
      top: '5%',
      bottom: 0,
      icon: 'circle',
      formatter: function (name) {
        const p = series.find((p) => p.name === name)
        return [`{name|${name}}`, `{p|${p.percent}}`, `${p.extraValue}`].join('')
      },
      textStyle: {
        fontSize: 12,
        width: 450,
        padding: [0, 4],
        rich: {
          name: {
            width: 80
          },
          p: {
            width: 50
          }
        }
      },
      itemGap: 8,
      data: legend
    },

    color: [
      '#F4941B',
      '#FFBC0A',
      '#32BB6B',
      '#494BE0',
      '#005AFE',
      '#EC507E',
      '#F786F0',
      '#AEC8BA',
      '#6F0771',
      '#7AB514',
      '#5FA850',
      '#348421',
      '#193036',
      '#A94ADE',
      '#BEEFF7',
      '#A777DC',
      '#2BF90C',
      '#F9C3AF',
      '#8D938A',
      '#7D58DD',
      '#2516C3',
      '#CFAFBC',
      '#4D13A5',
      '#F14A83',
      '#939631',
      '#F2092C',
      '#4B474E',
      '#3BC2D',
      '#2471E6',
      '#93E586',
      '#4D59E3',
      '#5A0F84',
      '#77BBDA',
      '#446408',
      '#F66746'
    ],
    series: [
      {
        name: '媒体分布',
        type: 'pie',
        radius: ['60%', '80%'],
        center: ['30%', '50%'],
        avoidLabelOverlap: false,
        // animation: false,
        label: {
          show: false,
          position: 'center'
        },
        itemStyle: {
          borderWidth: 5,
          borderColor: '#fff'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '30',
            fontWeight: 'bold'
          }
        },
        labelLine: {
          show: false
        },
        data: series
      }
    ]
  }
}
